export default __webpack_public_path__ + "static/media/kitchen4-afterE-1440w.ab1ad477.webp";